<template>

    <div v-if="p_sideMissions_ac != null && p_teamStatus_c != null" class="lc_MissionsList TQ_maxWidth_600px TQ_center">

        <!-- 1) with GROUPS-->
        <tq-toggle-div v-if="p_support_missionGroups_b"
                       v-for="(qb_missionsGroup_c) in p_missionsGroups_ac"
                       :key="qb_missionsGroup_c.qbmg_missionsGroupId_n"
                       :pf_toggle-active_b="!p_support_missionGroupsLevel_b || m_finishLevel_fb(qb_missionsGroup_c)"
                       class="TQ_bg_white TQ_margin_8px_0 TQ_padding_4px_0" >


            <div slot="header" class="TQ_grid_col_auto1fr">

                <!-- image -->
                <div class="TQ_padding_4px TQ_grid_verticalCenter">

                    <on-top-container>
                        <!--<img slot="body"-->
                             <!--class="TQ_width_72px"-->
                             <!--:src="qb_missionsGroup_c.qbmg_imgFile_c ? qb_missionsGroup_c.qbmg_imgFile_c.fi_url_s : ass_img_image"/>-->

                        <div slot="body"  class="TQ_width_72px">
                            <tq-img-fill-blur p_height_s="52px"
                                              :pp_img-url_s="qb_missionsGroup_c.qbmg_imgFile_c ? qb_missionsGroup_c.qbmg_imgFile_c.fi_url_s : ass_img_image"/>
                        </div>


                        <div slot="bottom" class="TQ_textColor_black TQ_text_14px">
                            <div v-if="m_getWaitingToApprovedImgsNum_fn(qb_missionsGroup_c.qbmg_riddlesIds_an) > 0"
                                 class="TQ_bg_gold TQ_center">
                                {{m_getWaitingToApprovedImgsNum_fn(qb_missionsGroup_c.qbmg_riddlesIds_an)}}
                            </div>
                            <div v-if="m_getNotApprovedImgsNum_fn(qb_missionsGroup_c.qbmg_riddlesIds_an) > 0"
                                 class="TQ_bg_red TQ_center">
                                {{m_getNotApprovedImgsNum_fn(qb_missionsGroup_c.qbmg_riddlesIds_an)}}
                            </div>
                        </div>
                    </on-top-container>
                </div>


                <div class="TQ_grid_verticalCenter TQ_margin_0_8px">

                    <!-- group title -->
                    <div class="TQ_text_24px TQ_textColor_purple_dark TQ_text_bold"> {{qb_missionsGroup_c.qbmg_name_byLangCode_s[p_display_langCode_e]}} </div>

                    <!-- level point -->
                    <div v-if="p_support_missionGroupsLevel_b" class="TQ_direction_ltr TQ_text_16px TQ_margin_0_8px">
                        <div v-if="m_finishLevel_fb(qb_missionsGroup_c)" class="TQ_bg_green TQ_borderRadius TQ_inline TQ_padding_4px">
                            <img :src="ass_img_unlock2" class="TQ_width_20px TQ_verticalAlignMiddle"/>
                            <div class="TQ_padding_2px TQ_inline TQ_verticalAlignMiddle"> </div>
                            <div class="TQ_inline TQ_verticalAlignMiddle">{{ass_strings.oneWord_unlock[p_display_langCode_e]}} </div>
                        </div>
                        <div v-else class="TQ_inline TQ_bg_red TQ_padding_4px TQ_borderRadius">
                            <img :src="ass_img_lock_w" class="TQ_width_20px TQ_verticalAlignMiddle"/>
                            <div class="TQ_padding_2px TQ_inline TQ_verticalAlignMiddle"> </div>
                            <div class="TQ_inline TQ_verticalAlignMiddle">
                                {{co_currentTeamTotalPoints_s}} / {{qb_missionsGroup_c.qbmg_pointsToUnlock_n}}
                            </div>
                        </div>
                    </div>
                </div>

            </div>


            <div  slot="body"
                  class="lc_groupMissionRow"
                  :key="index_n"
                  v-for="(qb_riddle_c, index_n) in m_getMissionGroupRiddles_ac(qb_missionsGroup_c.qbmg_riddlesIds_an)">

                <hr v-if="index_n===0">

                <tq-missions-list_row
                        :key="qb_riddle_c.qbr_riddleId_n"
                        :p_qb_riddle_c="qb_riddle_c"
                        :p_team-status-missions_by-riddle-id_c="p_teamStatusMissions_byRiddleId_c"
                        :p_display_lang-code_e="p_display_langCode_e"
                        :p_support-points_b="p_supportPoints_b"
                        @click.native="pe_clickMission_f(qb_riddle_c.qbr_riddleId_n)"
                />

                <hr>
            </div>

        </tq-toggle-div>

        <!-- 2) WITHOUT GROUPS -->
        <tq-missions-list_row
                v-for="riddleIndex in co_getOrderSideMissionsIndexes_an"
                :key="p_sideMissions_ac[riddleIndex].qbr_riddleId_n"
                v-if="!p_support_missionGroups_b"
                :p_qb_riddle_c="p_sideMissions_ac[riddleIndex]"
                :p_team-status-missions_by-riddle-id_c="p_teamStatusMissions_byRiddleId_c"
                :p_display_lang-code_e="p_display_langCode_e"
                :p_support-points_b="p_supportPoints_b"
                :p_window-size-type_e="pp_windowSizeType_e"
                @click.native="pe_clickMission_f(p_sideMissions_ac[riddleIndex].qbr_riddleId_n)"
        />

    </div>

</template>

<script>
    import TqList from "./TqList";
    import OnTopContainer from "../basic/TqOnTopContainer";
    import {
        helper_finishRiddle_fb,
        helper_getDirectionByLangCode_fe, helper_getRiddleWithRiddleId_fc
    } from "../../scripts/S_Helper";
    import TqLoaderContainer from "../basic/TqLoaderContainer";
    import {
        enum_lockState,
        } from "../../../functions/src/shareCode/Share_S_Enum";
    import {validator_enum_fb} from "../../../functions/src/shareCode/Share_S_Validator";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {
        ass_img_garbage_w,
        ass_img_image, ass_img_lock_w,
        ass_img_unlock2_w
    } from "../../assets/scripts/Ass_Files";
    import TqToggleDiv from "../basic/TqToggleDiv";
    import TqMissionsList_row from "./TqMissionsList_row";
    import {validator_arrayClass_fb} from "../../../functions/src/shareCode/Share_S_Validator";
    import {enum_langCodes, enum_lockTypes, enum_screenSizesOptions_n} from "../../../functions/src/shareCode/Share_S_Enum";
    import TqImgFillBlur from "../basic2/TqImgFillBlur";
    import {
        FB_GameStatus,
        FB_QuestBody_MissionsGroup,
        FB_QuestBody_Riddle, FB_TeamStatus
    } from "../../../functions/src/shareCode/Share_S_Classes";


    export default {
        name: "TqMissionsList",
        components: {TqImgFillBlur, TqMissionsList_row, TqToggleDiv, TqLoaderContainer, OnTopContainer, TqList},
        props:{

            p_missionsGroups_ac : {
                type: Array,
                require: true,
                validator(arr){
                    return validator_arrayClass_fb(arr, FB_QuestBody_MissionsGroup)
                }
            },
            p_teamStatus_c : {
                type: FB_TeamStatus,
                require: true,
            },
            p_gameStatus_c : {
                type: FB_GameStatus,
                require: true,
            },

            // ======== missions groups ===========
            p_support_missionGroups_b:{
                type: Boolean,
                default: false,
            },
            p_supportPoints_b:{
                type: Boolean,
                default: false,
            },
            p_support_missionGroupsLevel_b:{
                type: Boolean,
                default: false,
            },

            // ========== others =============
            p_sideMissions_ac:{
                type: Array,
                require: true,
                validator(arr){
                    return validator_arrayClass_fb(arr, FB_QuestBody_Riddle)
                }
            },
            p_teamStatusMissions_byRiddleId_c:{
                type: Object,
                require: true
            },
            p_display_langCode_e:{
                type: String,
                require: true,
                validator(langCode){
                    return validator_enum_fb(enum_langCodes, langCode)
                }
            },
            p_orderMissions_b:{
                type : Boolean,
                default : false
            },

            pp_windowSizeType_e:{},

            // ======== functions =============
            pe_clickMission_f:{
                type: Function,
                require: true
            }
        },
        data(){
            return {

                ass_strings: ass_strings,
                ass_img_garbage_w: ass_img_garbage_w,
                ass_img_image : ass_img_image,
                enum_screenSizeType : enum_screenSizesOptions_n,
                ass_img_unlock2 : ass_img_unlock2_w,
                ass_img_lock_w : ass_img_lock_w,

                helper_finishRiddle_fb : helper_finishRiddle_fb,
                helper_getDirectionByLangCode_fe : helper_getDirectionByLangCode_fe,

            }
        },
        computed:{
            // co_getOrderSideMissionsIndexes
            co_getOrderSideMissionsIndexes_an() {
                return this.p_sideMissions_ac.map((tq_mission_c, index_n) => {return index_n})
            },

            // co_currentTeamTotalPoints_s
            co_currentTeamTotalPoints_s() {
                
                if(this.p_gameStatus_c == null){
                    return 0
                }

                return this.p_gameStatus_c.gs_teams_byTeamId[this.p_teamStatus_c.ts_teamId_uid].gst_m_totalPoints_n()
            }

        },
        methods:{
            m_getMissionGroupRiddles_ac(riddlesIds_an){

                if(riddlesIds_an == null){
                    riddlesIds_an = this.p_sideMissions_ac.map(item => {return item.qbr_riddleId_n})
                }

                let orderArr = []
                let firstFinishMission = 0

                riddlesIds_an.forEach(riddleId_n =>{

                    let questBody_riddle_c = helper_getRiddleWithRiddleId_fc(this.p_sideMissions_ac, riddleId_n)

                    if(questBody_riddle_c == null)
                        return

                    if(!this.p_orderMissions_b){
                        orderArr.push(questBody_riddle_c)
                    } else if(this.p_teamStatusMissions_byRiddleId_c[riddleId_n] != null){
                        // if(this.p_teamStatusMissions_byRiddleId_c[mission.qbr_riddleId_n].finish === true) {
                        if(helper_finishRiddle_fb(
                            questBody_riddle_c,
                            this.p_teamStatusMissions_byRiddleId_c[riddleId_n])) {
                            orderArr.splice(firstFinishMission,0,questBody_riddle_c)
                        }else{
                            orderArr.unshift(questBody_riddle_c)
                            firstFinishMission++
                        }
                    }else {
                        orderArr.push(questBody_riddle_c)
                    }
                });



                return orderArr

            },
            m_showFinishIcon_b(qb_riddle_c){
                return helper_finishRiddle_fb(qb_riddle_c, this.p_teamStatusMissions_byRiddleId_c[qb_riddle_c.qbr_riddleId_n])
            },
            m_getWaitingToApprovedImgsNum_fn(qbmg_riddlesIds_an){


                let ans = 0
                this.m_getMissionGroupRiddles_ac(qbmg_riddlesIds_an).forEach(qb_riddleData_c => {

                    let riddleId_n = qb_riddleData_c.qbr_riddleId_n
                    let notApprovedImgs_n = 0

                    qb_riddleData_c.qbr_locks_ac.forEach((qbr_lock_c, lockId_n) => {
                        if([enum_lockTypes.IMAGE, enum_lockTypes.VIDEO].includes(qbr_lock_c.qbrl_type_e)){

                            if(this.p_teamStatusMissions_byRiddleId_c[riddleId_n] == null || this.p_teamStatusMissions_byRiddleId_c[riddleId_n].rs_unlock_byLockId_c == null){
                                return
                            }

                            let riddleStatus_unlock_c = this.p_teamStatusMissions_byRiddleId_c[riddleId_n].rs_unlock_byLockId_c[lockId_n]
                            if(riddleStatus_unlock_c != null && riddleStatus_unlock_c.rsud_lockState_e === enum_lockState.waitingToApprove && riddleStatus_unlock_c.rsud_skip_b === false){
                                notApprovedImgs_n++
                            }
                        }
                    })

                    ans+=notApprovedImgs_n
                })

                return ans
            },
            m_getNotApprovedImgsNum_fn(qbmg_riddlesIds_an){


                let ans = 0
                this.m_getMissionGroupRiddles_ac(qbmg_riddlesIds_an).forEach(qb_riddleData_c => {

                    let riddleId_n = qb_riddleData_c.qbr_riddleId_n
                    let notApprovedImgs_n = 0

                    qb_riddleData_c.qbr_locks_ac.forEach((qbr_lock_c, lockId_n) => {
                        if([enum_lockTypes.IMAGE, enum_lockTypes.VIDEO].includes(qbr_lock_c.qbrl_type_e)){

                            if(this.p_teamStatusMissions_byRiddleId_c[riddleId_n] == null || this.p_teamStatusMissions_byRiddleId_c[riddleId_n].rs_unlock_byLockId_c == null){
                                return
                            }

                            let riddleStatus_unlock_c = this.p_teamStatusMissions_byRiddleId_c[riddleId_n].rs_unlock_byLockId_c[lockId_n]
                            if(riddleStatus_unlock_c != null && riddleStatus_unlock_c.rsud_lockState_e === enum_lockState.notApproved){
                                notApprovedImgs_n++
                            }
                        }
                    })

                    ans+=notApprovedImgs_n
                })


                return ans
            },
            m_finishLevel_fb(qb_missionsGroup_c){
                return qb_missionsGroup_c.qbmg_pointsToUnlock_n <= this.co_currentTeamTotalPoints_s
            }
        }
    }
</script>

<style scoped lang="scss">

    .lc_groupMissionRow {
        padding-right: 16px;
        padding-left: 16px;
    }

    .lc_MissionsList{
        text-align: initial;

        .mission{
            cursor: pointer;

            &:hover{
                color: var(--color-gold);
            }
        }
    }

</style>